<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { TYPES as ORG_IPA_ADDRESS_TYPES } from './store'
import { hasPerm } from '@/components/PermissionHelper'

import ThuxListMixin from '../../../../components/thux-list/ThuxListMixin'

import OrganizationIpaAddressTable from './OrganizationIpaAddressTable'
import OrganizationIpaAddressEdit from './OrganizationIpaAddressEdit.vue'

export default {
  name: 'OrganizationIpaAddressList',
  props: ['orgId'],
  mixins: [ThuxListMixin],
  components: {
    'component-table': OrganizationIpaAddressTable,
    'component-edit': OrganizationIpaAddressEdit
  },
  data () {
    return {
      title: this.$t('IPA Addresses'),
      rolePerm: ['organization_ipaaddress_list'],
      actionEnablePermission: ['organization_ipaaddress_enable'],
      actionDisablePermission: ['organization_ipaaddress_disable'],
      showHeader: false,
      showCommonFilters: false,
      searchFields: []
    }
  },
  computed: {
    ...mapGetters({
      ...ORG_IPA_ADDRESS_TYPES.GENERIC.organization.organizationipaaddress.LIST.GETTERS
    }),
    canSeeActionSelect () {
      return true
    },
    canAddInstance () {
      return hasPerm('organization_ipaaddress_create')
    }
  },
  methods: {
    ...mapMutations({
      setSelectedList: ORG_IPA_ADDRESS_TYPES.GENERIC.organization.organizationipaaddress.LIST.MUTATIONS.setSelectedList,
      setSelectAll: ORG_IPA_ADDRESS_TYPES.GENERIC.organization.organizationipaaddress.LIST.MUTATIONS.setSelectAll
    }),
    ...mapActions({
      ...ORG_IPA_ADDRESS_TYPES.GENERIC.organization.organizationipaaddress.LIST.ACTIONS
    }),
    getComponentList () {
      this.setFilters({ filter__holder__id: this.orgId })
    },
    openEditForm (id) {
      this.$set(this.editParams, 'orgId', this.orgId)
      if (id) {
        this.$set(this.editParams, 'addressId', id)
      } else {
        this.$set(this.editParams, 'addressId', undefined)
      }
      this.$set(this, 'componentId', id)
      this.$set(this, 'showEditForm', true)
      this.$set(this, 'showDetailForm', false)
    }
  }
}
</script>
